import { render, staticRenderFns } from "./CompanyDepartmentsTable.vue?vue&type=template&id=3f2d55b7&scoped=true"
import script from "./CompanyDepartmentsTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompanyDepartmentsTable.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CompanyDepartmentsTable.vue?vue&type=style&index=0&id=3f2d55b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2d55b7",
  null
  
)

export default component.exports